import { render, staticRenderFns } from "./LoaderBar.vue?vue&type=template&id=7ed136e2&"
import script from "./LoaderBar.vue?vue&type=script&lang=js&"
export * from "./LoaderBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports